import React, { Component } from "react";
import WmsCollapse from "../../components/WmsCollapse/WmsCollapse.jsx";
import WmsInput from "../../components/WmsInput/WmsInput.jsx";

export class StampsAccountInfoComponent extends Component {

    constructor(props) {
        super(props);
        
        this.translate = window.translate;
        this.$rootScope = window;
        this.state = { }
    }


    render() {
        return (
            <WmsCollapse
                id={"carrierAccountInformation"}
                headerLabel={this.translate("Label_Account_Information")}
                showCollapseText={false}
                showCollapseIcon={false}
            >
                <div className="account-info-section">
                    <WmsInput
                        id="accountNumber"
                        inputName="AccountNumber"
                        wmsSelector={this.props.selector + "accountNumber"}
                        onChangeFunc={this.props.handleConnectionObjChange}
                        label={this.props.currentLoginLabel}
                        required={true}
                        value={this.props.connectionObj.AccountNumber}
                    />
                    <WmsInput
                        id="password"
                        inputType={"password"}
                        inputName="Passphrase"
                        wmsSelector={this.props.selector + "password"}
                        onChangeFunc={this.props.handleConnectionObjChange}
                        label={this.translate("Login_Lbl_Password")}
                        required={true}
                        value={this.props.connectionObj.Passphrase}
                    />
                    <WmsInput
                        id="nickname"
                        inputName="Nickname"
                        wmsSelector={this.props.selector + "nickname"}
                        onChangeFunc={this.props.handleConnectionObjChange}
                        label={this.translate("Label_Nick_Name")}
                        required={true}
                        value={this.props.connectionObj.Nickname}
                    />
                </div>
            </WmsCollapse>
        );
    }
}
